import { makeEntityStringId } from 'app/types/entity';
import { makeGuid } from 'app/types/guid';

export const DAILY_NEWS_COURSE_ID = makeEntityStringId(makeGuid('0225ae09-5d63-41c2-bd75-693985d07d79'));

export enum CourseQueryParam {
  CourseId = 'course_id',
}
